import React from "react";
import { RequestBox } from "src/components/FeedContainer";
import { DraftConnectionTypeIconWithHoverTip } from "src/components/Icons";
import { DraftsTableRow } from "../types";
import { useDraftsNavigation } from "../hooks";

export const DraftBox = ({ row }: { row: DraftsTableRow }) => {
  const { handleOnClick } = useDraftsNavigation(row);
  const primaryIcon = React.useMemo(
    () => (
      <DraftConnectionTypeIconWithHoverTip
        type={row.connectionType}
        state={row.state}
        channel={row.requestChannel}
        requestType={row.requestType}
        serviceType={row.serviceType}
      />
    ),
    [
      row.connectionType,
      row.state,
      row.requestChannel,
      row.requestType,
      row.serviceType,
    ]
  );

  return (
    <RequestBox
      primaryIcon={primaryIcon}
      primaryText={row.address}
      secondaryText={row.id}
      summaryText={row.statusText}
      onClick={handleOnClick}
      data-id={`draftBox.${row.id}`}
    />
  );
};
